import { asArray } from "ol/color";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import { Stroke } from "ol/style";
import Circle from "ol/style/Circle";

export function getStyle(type, fillColor, strokeColor) {
  const colorFill = asArray(fillColor);
  colorFill[3] = 0.1;
  const colorStroke = strokeColor;
  switch (type) {
    // case "Polygon":
    //   return new Style({
    //     fill: new Fill({
    //       color: colorFill
    //     }),
    //     stroke: new Stroke({
    //       color: colorStroke,
    //       width: 2
    //     })
    //   });
    // case "Circle":
    //   return new Style({
    //     fill: new Fill({
    //       color: colorFill
    //     }),
    //     stroke: new Stroke({
    //       color: colorStroke,
    //       width: 2
    //     })
    //   });
    case "LineString":
      return new Style({
        stroke: new Stroke({
          color: colorStroke,
          width: 2
        })
      });
  }

  return new Style({
    fill: new Fill({
      color: colorFill
    }),
    stroke: new Stroke({
      color: colorStroke,
      width: 2
    })
  });
}
